import { ShouldNotHappen } from 'utils';

import {
  VideoTutorielDto,
  VideoTutorielDtoProfileEnum,
  VideoTutorielRequestDto,
  VideoTutorielRequestDtoProfileEnum,
} from 'lib_api/lib/api/gen';

import { VideoFormValue } from './type';

export function buildDto(values: VideoFormValue): VideoTutorielRequestDto {
  return {
    profile: values.profile || null,
    videoId: values.videoId || null,
  };
}

export function buildDefaultUpdateFormValues(
  video: VideoTutorielDto,
): VideoFormValue {
  return {
    profile: mapVideoTutorielDtoProfileEnumtoVideoTutorielRequestDtoProfileEnum(
      video.profile,
    ),
    videoId: video.videoId,
  };
}

function mapVideoTutorielDtoProfileEnumtoVideoTutorielRequestDtoProfileEnum(
  value: VideoTutorielDtoProfileEnum,
): VideoTutorielRequestDtoProfileEnum {
  switch (value) {
    case VideoTutorielDtoProfileEnum.FORCE_DE_L_ORDRE:
      return VideoTutorielRequestDtoProfileEnum.FORCE_DE_L_ORDRE;
    case VideoTutorielDtoProfileEnum.AUTORITE_FOURRIERE:
      return VideoTutorielRequestDtoProfileEnum.AUTORITE_FOURRIERE;
    case VideoTutorielDtoProfileEnum.GARDIEN_FOURRIERE:
      return VideoTutorielRequestDtoProfileEnum.GARDIEN_FOURRIERE;
    case VideoTutorielDtoProfileEnum.ADMIN_FONCTIONNEL:
      return VideoTutorielRequestDtoProfileEnum.ADMIN_FONCTIONNEL;
    case VideoTutorielDtoProfileEnum.DSR_BLR:
      return VideoTutorielRequestDtoProfileEnum.DSR_BLR;
    case VideoTutorielDtoProfileEnum.CSU:
      return VideoTutorielRequestDtoProfileEnum.CSU;
    case VideoTutorielDtoProfileEnum.TRIBUNAL_JUDICIAIRE:
      return VideoTutorielRequestDtoProfileEnum.TRIBUNAL_JUDICIAIRE;
    case VideoTutorielDtoProfileEnum.COUR_APPEL:
      return VideoTutorielRequestDtoProfileEnum.COUR_APPEL;
    case VideoTutorielDtoProfileEnum.UNITE_OPERATIONNELLE:
      return VideoTutorielRequestDtoProfileEnum.UNITE_OPERATIONNELLE;
    case VideoTutorielDtoProfileEnum.NATIONAL_JUSTICE:
      return VideoTutorielRequestDtoProfileEnum.NATIONAL_JUSTICE;
    default:
      throw new ShouldNotHappen(value);
  }
}
